import { z } from "zod";

export const healthResponseSchema = z.object({
  /** `unavailable` (with a 503) while the schema is behind the build or cannot be read. */
  status: z.enum(["ok", "unavailable"]),
  buildId: z.string(),
  /** The release version (`2026.10.30`, `2026.10.30+3.<sha>` or `dev`). Optional for the previous release. */
  version: z.string().optional(),
  /** The product help corpus this build embeds (pages served inside tenants). */
  help: z.object({ pages: z.int().min(0) }).optional(),
  /**
   * Schema readiness (ADR 0013): the migration version the build requires, the one applied
   * (null when the database could not be read) and whether it is at least the required one.
   * Optional for clients of the previous release.
   */
  schema: z
    .object({
      required: z.number().int(),
      applied: z.number().int().nullable(),
      ready: z.boolean(),
    })
    .optional(),
});

export type HealthResponse = z.infer<typeof healthResponseSchema>;
